/** Flatten tranche + dispatch params for `{{ params.key }}` substitution. */
export function flattenEpkParams(
  params: Record<string, unknown>,
  extras?: Record<string, string | number | boolean>,
): Record<string, string> {
  const out: Record<string, string> = {}
  const assign = (key: string, val: unknown) => {
    if (val === null || val === undefined) return
    if (typeof val === 'object') return
    out[key] = String(val)
  }
  for (const [k, v] of Object.entries(params)) assign(k, v)
  if (extras) {
    for (const [k, v] of Object.entries(extras)) assign(k, v)
  }
  return out
}

/** Replace Brevo-style `{{ params.X }}` placeholders in draft HTML/CSS. */
export function substituteEpkPlaceholders(
  template: string,
  params: Record<string, string>,
): string {
  let out = template
  for (const [key, val] of Object.entries(params)) {
    const patterns = [`{{ params.${key} }}`, `{{params.${key}}}`, `{{ ${key} }}`]
    for (const p of patterns) out = out.split(p).join(val)
  }
  return out
}

export function renderEpkDocument(
  htmlBody: string,
  cssBody: string,
  params: Record<string, unknown>,
  extras?: Record<string, string | number | boolean>,
): string {
  const flat = flattenEpkParams(params, extras)
  const html = substituteEpkPlaceholders(htmlBody, flat)
  const css = substituteEpkPlaceholders(cssBody, flat)
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><style>${css}</style></head><body>${html}</body></html>`
}
